import { render, staticRenderFns } from "./productcategories.vue?vue&type=template&id=4c1628a4&scoped=true"
import script from "./productcategories.vue?vue&type=script&lang=js"
export * from "./productcategories.vue?vue&type=script&lang=js"
import style0 from "./productcategories.vue?vue&type=style&index=0&id=4c1628a4&prod&scoped=true&lang=css"
import style1 from "./productcategories.vue?vue&type=style&index=1&id=4c1628a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1628a4",
  null
  
)

export default component.exports